import { render, staticRenderFns } from "./homeTestTask.vue?vue&type=template&id=f734214a&"
import script from "./homeTestTask.vue?vue&type=script&lang=js&"
export * from "./homeTestTask.vue?vue&type=script&lang=js&"
import style0 from "./homeTestTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports